import { useDispatch, useSelector } from "react-redux";
import { setPostions } from "../../store/slice/application";
import { Col, FormGroup, FormLabel } from "react-bootstrap";
import RenderField from "../RenderField";
import { useEffect, useMemo, useState } from "react";
import countryList from "react-select-country-list";

const Postions = ({ positions, handlePostionClick, register, errors, watch, setValue, control, setRwanda, rwanda ,setShowButton}) => {
    const { postions } = useSelector((state) => state.application);
    const options = useMemo(() => countryList().getData(), []);
    const [selectedPositions, setSelectedPositions] = useState(postions);

    const dispatch = useDispatch();
    const internationalPositions = positions?.filter((position) => position.international)
    const availablePositions = rwanda ? positions : internationalPositions
  
    useEffect(() => {
        if (availablePositions.length > 0) {
            setShowButton(true)
        } else {
            setShowButton(false)
        }
    }, [availablePositions])

    useEffect(() => {
        watch((value, { name, type }) => {
            if (type === "change") {
                if (name === "nationality") {
                    dispatch(setPostions([]))
                    setSelectedPositions([])
                    setRwanda(value[name] === "Rwanda");
                    setValue('nationalId', null);

                }
            }
        });
    }, [watch]);

    useEffect(() => {
        if (rwanda===true) {
        setValue('nationality', 'Rwanda');
        setRwanda(true)
    }
    }, []);

    const handleSelect = (postion) => {

      
        if (selectedPositions.filter(item => item.id === postion.id).length > 0) {
            setSelectedPositions(selectedPositions.filter(item => item.id !== postion.id))
            dispatch(setPostions(selectedPositions.filter(item => item.id !== postion.id)))
        } else {
    
            setSelectedPositions([postion])
            dispatch(setPostions([postion]))
        }
    }

    useEffect(() => {

        setSelectedPositions(postions)

       
    }
        , [postions])

    return (
        <div className={`w-full flex flex-col justify-center items-center  `}>
            <div className="mt-2 w-full md:w-1/2">
                <FormGroup className={"mb-3"}>
                    <FormLabel className={""}>
                        <span className="text-textColor mb-2 md:text-[15px] font-bold">
                        Select Nationality
                        </span>
                    </FormLabel>
                    <RenderField
                    
                        type={"country"}
                        control={control}
                        label={"Nationality"}
                        values={[{ label: "-- select nationality --", value: "" }].concat(
                            options.map((item) => ({
                                label: item.label,
                                value: item.label,
                            }))
                        )}
                        placeholder={"Rwanda"}
                        name={"nationality"}
                        required={true}
                        register={register}
                        errors={errors}
                    />
                </FormGroup>
            </div>
{ positions && availablePositions.length > 0 && 
            <div className="flex flex-col w-full md:w-1/2 mt-2">

            <FormLabel className={""}>
                        <span className="text-textColor md:text-[15px] font-bold">
                        Select Your Preferred Position
                        </span>
                    </FormLabel>
            <div className="flex flex-col gap-2.5  w-full mt-1">
          
                {positions && availablePositions.map((postion, index) => {

                    return (
                        <div
                            className={`flex items-center gap-[3em] cursor-pointer relative}`}
                     
                        >
                            <div className="flex items-center ">
                            <input
                                type="radio"
                                checked={selectedPositions.filter(item => item.id === postion.id).length > 0 || postions.filter(item => item.id === postion.id).length > 0}
                                onChange={() => 
                                {
                                    handleSelect(postion)
                                }
                                }
                               
                                
                                style={{ cursor: "pointer",     
                                   outline: "none",
                            accentColor: "#054166",
                                   height:"18px",
                                      width:"18px",
                                    
                                   }}
                           className="mr-2 border-2 rounded cursor-pointer 
                           
    border-3 rounded-lg checked:bg-rose-600"
                            />
                            <span className="text-[14px] md:text-[18px] text-normal">{postion.name}</span>

                            </div>
                            {/* 
                            link if there is requirement for the position
                            */}
                            {
                                postion.requirements && (
                                    <span onClick={() => handlePostionClick(postion)} className="text-[10px] text-normal text-[#008DCA] ">
                                        <a href="#" style={{
                                            color:"#008DCA"
                                        }} rel="noreferrer">
                                        View Job Description
                                        </a>
                                    </span>
                                )
                            }
                           
                              
                            
                        </div>
                    )})}
            </div>
            </div>
}
        </div>
    );
}

export default Postions;
